import React, { Component } from 'react';

import {
    View,
    Image,
    StyleSheet
} from 'react-native';
import {
    JDText,
    JDImage,
    JDCountDown
} from '@jdreact/jdreact-core-lib';

import { pt, complement } from '../../common/utils';
const img = {
    time: require('../../img/order/time.png'),
    bac: require('../../img/order/bac.png')
};

export default class CountDown extends Component {
    constructor(props) {
        super(props);
        this.state = {
            show: true,
            time: 0
        };
        this._timeOut = this._timeOut.bind(this);
    }

    render() {
        const { show, time } = this.state;

        const { style } = this.props;

        const now = Date.now();

        return (
            time > 0 && show && <JDImage
                source={ img.bac }
                style={ [st.time, style] }
            >
                <View style={ st.v_time }>
                    <Image style={ st.time_img } source={ img.time } />
                    <JDCountDown
                        key={ now }
                        endDate={ now + time }
                        onEnd={ this._timeOut }
                        startDate={ now }
                        renderCountDown={ this._cusCountDown }
                        interval={ 1000 }
                        containerStyle={ { backgroundColor: 'transparent' } }
                        daysStyle={ st.txt }
                        daysTextStyle={ st.txt }
                        hoursStyle={ st.txt }
                        firstColonStyle={ st.txt }
                        minsStyle={ st.txt }
                        secondColonStyle={ st.txt }
                        secsStyle={ st.txt }
                    />
                </View>
            </JDImage>
        );
    }

    componentDidMount() {
        const { minutes, seconds } = this.props;

        this.setState({
            time: minutes * 60 * 1000 + seconds * 1000
        });
    }

    componentWillReceiveProps(nextProps) {
        const { minutes, seconds } = nextProps;

        this.setState({
            time: minutes * 60 * 1000 + seconds * 1000
        });
    }

    // componentWillUnmount(){
    //     this.setState({
    //         show: false
    //     })
    // }

    _cusCountDown(countDownProps, leftTime) {
        const minutes = parseInt(leftTime / 60 / 1000);

        const seconds = parseInt((leftTime / 1000) - (minutes * 60));

        return (
            <JDText style={ st.time_txt }>{complement(minutes)}:{complement(seconds)}</JDText>
        );
    }

    _timeOut() {
        const { timeOut } = this.props;

        this.setState({
            show: false
        });
        timeOut();
    }
}

const st = StyleSheet.create({
    time: {
        position: 'absolute',
        right: 0,
        top: pt(10),
        height: pt(29),
        width: pt(70),
        justifyContent: 'center',
        alignItems: 'center',
        borderBottomLeftRadius: pt(29),
        borderTopLeftRadius: pt(29)
    },
    v_time: {
        justifyContent: 'center',
        flexDirection: 'row',
        alignItems: 'center'
    },
    time_img: {
        height: pt(16),
        width: pt(16),
        marginRight: pt(6)
    },
    time_txt: {
        fontSize: pt(13),
        backgroundColor: 'transparent',
        color: '#fff'
    },
    txt: {
        fontSize: pt(13),
        backgroundColor: 'transparent',
        color: '#fff'
    }
})
;
